'use client';
import React from 'react';
import { Grid, PageTitle } from '@develos/next-components';
import { useTranslations } from '@develos/next-library';
import DetailsOverview from './components/DetailsOverview';
import ControlsSection from './components/ControlsSection';
import ListOfVehicles from './components/ListOfVehicles';

const LiveVehiclesRecords = () => {
  const { translate } = useTranslations();

  return (
    <div className="rm-relative rm-h-full rm-w-full">
      <PageTitle title={translate('Ruch drogowy | Podgląd na żywo', 'VehicleList')} dataTestId='live-vehilces-page-title' />
      <Grid columns={1} xlColumns={2} gap={5}>
        <div className="rm-relative">
          <DetailsOverview />
        </div>
        <div className="rm-relative">
          <ControlsSection />
          <ListOfVehicles />
        </div>
      </Grid>
    </div>
  );
};

export default LiveVehiclesRecords;
